import * as i0 from '@angular/core';
import { Directive, Inject, Input, Pipe, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1 from '@aihub/core/utils';
import { AiHubUtilsModule } from '@aihub/core/utils';
import { startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

class AiHubStickyDirective {
    constructor(doc, windowScroll, host, renderer, zone) {
        this.doc = doc;
        this.windowScroll = windowScroll;
        this.host = host;
        this.renderer = renderer;
        this.zone = zone;
        this.keepTop = false;
        this.initialTop = 0;
        this.destroy$ = new Subject();
    }
    ngAfterViewInit() {
        this.zone.runOutsideAngular(() => {
            setTimeout(() => {
                const left = this.getOffset('left');
                this.initialTop = this.getOffset('top');
                this.bounds = this.host.nativeElement.getBoundingClientRect();
                /** dont like it */
                this.renderer.setStyle(this.host.nativeElement, 'width', `${this.bounds.width}px`);
                this.renderer.setStyle(this.host.nativeElement, 'height', `${this.bounds.height}px`);
                this.renderer.setStyle(this.host.nativeElement, 'left', `${left}px`);
                this.renderer.setStyle(this.host.nativeElement, 'top', this.keepTop ? `${this.initialTop}px` : `0px`);
                this.windowScroll.onChange()
                    .pipe(startWith({
                    x: this.doc.defaultView.scrollX,
                    y: this.doc.defaultView.scrollY
                }), takeUntil(this.destroy$))
                    .subscribe((scrollBy) => this.repositionHost(scrollBy));
            }, 0);
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
        this.destroy$ = null;
    }
    repositionHost(scrollBy) {
        const fixElement = scrollBy.y > (this.keepTop ? 0 : this.initialTop);
        const parentBounds = this.host.nativeElement.parentElement.getBoundingClientRect();
        if (fixElement) {
            this.renderer.setStyle(this.host.nativeElement, 'position', `fixed`);
            const overflow = Math.min(parentBounds.height - (scrollBy.y + this.bounds.height), 0);
            const newTop = (this.keepTop ? this.initialTop : 0) + overflow;
            this.renderer.setStyle(this.host.nativeElement, 'top', `${newTop}px`);
        }
        else {
            this.renderer.setStyle(this.host.nativeElement, 'position', `initial`);
        }
    }
    getOffset(from) {
        let offset = 0;
        let el = this.host.nativeElement;
        while (el) {
            offset += from === 'top' ? el.offsetTop : el.offsetLeft;
            el = el.offsetParent;
        }
        return offset;
    }
}
AiHubStickyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubStickyDirective, deps: [{ token: DOCUMENT }, { token: i1.WindowScroll }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
AiHubStickyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: AiHubStickyDirective, selector: "[aihubSticky]", inputs: { keepTop: "keepTop" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubStickyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aihubSticky]',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: i1.WindowScroll }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.NgZone }];
    }, propDecorators: { keepTop: [{
                type: Input
            }] } });

class AihubFillLeftPipe {
    transform(item, token = ' ', length) {
        return (String(token).repeat(length) + item).substr((length * -1), length);
    }
}
AihubFillLeftPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AihubFillLeftPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
AihubFillLeftPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AihubFillLeftPipe, name: "aihubFillLeft", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AihubFillLeftPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'aihubFillLeft',
                    pure: false
                }]
        }] });

class AiHubCommonModule {
}
AiHubCommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AiHubCommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubCommonModule, declarations: [AiHubStickyDirective,
        AihubFillLeftPipe], imports: [CommonModule,
        AiHubUtilsModule], exports: [AiHubStickyDirective,
        AihubFillLeftPipe] });
AiHubCommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubCommonModule, imports: [[
            CommonModule,
            AiHubUtilsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AiHubStickyDirective,
                        AihubFillLeftPipe
                    ],
                    imports: [
                        CommonModule,
                        AiHubUtilsModule
                    ],
                    exports: [
                        AiHubStickyDirective,
                        AihubFillLeftPipe
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AiHubCommonModule, AiHubStickyDirective, AihubFillLeftPipe };
